import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import {
  Block,
  BlockDes,
  PreviewCard,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  BackTo,
  responseData,
  loading,
} from "../../../components/Component";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";
// import { blukUploadInventoryProducts } from "../../redux/fulfillmentCenter/action";
import { useHistory } from "react-router-dom";
import "./style.scss";
// import LoadingSpinner from "../../components/Loader/Loader";
// import AlertMessage from "../../components/SharedComponents/AlertMessage";
import { loginAxios } from '../../../config/axios.config';
import { useMutation, useQuery } from "@tanstack/react-query";
import { toast, ToastContainer } from "react-toastify";
import {Spinner } from "reactstrap";
import {useSelector, useDispatch} from 'react-redux';

const BulkUpdateAdd = () => {

  const history = useHistory();
  const dispatch = useDispatch();

  const [csvFile, setCsvFile] = useState();
  const ref = React.useRef();
  const uploadFile = (fileDetails) => {
    console.log(fileDetails);
    setCsvFile(fileDetails);
  };

  const bulkUpdate = async (params) => {
    try {
        const { data } = await loginAxios.post(`designers/bulk_product_upload`, params, {
            headers: {
                'x-auth-token': localStorage.getItem('accessToken'),
                'Content-Type': 'multipart/form-data' 
            }
        });
        return data;

    } catch (error) {
        return Promise.reject(error);
    }
};

  const bulkUpdateCall = useMutation(bulkUpdate, {
    onSettled(data, error) {
      if (data) {

        // console.log(data);

        let tmpPayload = {
          msg: data.message,
          status: true
        }        

        dispatch({type: 'BULK_UPDATE_FILE_UPLOAD', payload: tmpPayload})

				// toast.success(data.message, {
				// 	position: "top-right",
				// 	autoClose: 2000,
				// 	hideProgressBar: true,
				// 	closeOnClick: true,
				// 	progress: false,
				//   });

      } else if (error) {
        console.log('found ERROR')

        let tmpPayload = {
          msg: error.response.data.message,
          status: false
        }        

        dispatch({type: 'BULK_UPDATE_FILE_UPLOAD', payload: tmpPayload})
        
				// toast.error(error.response.data.message, {
				// 	position: "top-right",
				// 	autoClose: 2000,
				// 	hideProgressBar: true,
				// 	closeOnClick: true,
				// 	progress: false,
				//   });
      }

      history.push('/bulk-update')

    }
  });



  const handleSubmit = async () => {
    ref.current.value = "";
    if (csvFile !== undefined) {
        console.log(csvFile);
        
        const formData = new FormData();
        formData.append("csv_file", csvFile);

        bulkUpdateCall.mutate(formData);


    //   blukUploadInventoryProducts(csvFile);
    }
  };

  var accord = document.getElementsByClassName("view");
  var i;

  for (i = 0; i < accord.length; i++) {
    accord[i].onclick = function () {
      this.classList.toggle("open");
      this.nextElementSibling.classList.toggle("open");
    };
  }

  return (
    <React.Fragment data-test="UploadBasedCurateProducts">
      <Head title="Upload based curate products"></Head>
      <Content page="component">
        
        <Block size="lg">
          <BlockHead>
            <BlockHeadContent>
              <BlockDes>
                <h3>Bulk Update</h3>
              </BlockDes>
            </BlockHeadContent>
          </BlockHead>
          <PreviewCard>
            <div className="bulk-upload">
              <label>Upload CSV File</label>
              <input type="file" name="file" accept=".csv" ref={ref} onChange={(e) => uploadFile(e.target.files[0])} />
              <button disabled={bulkUpdateCall.isLoading} className="btn btn-primary btn-sm mt-2" onClick={handleSubmit}>
                
                {bulkUpdateCall.isLoading ? <Spinner size="sm" color="light" /> : "Upload"}
              </button>
            </div>
          </PreviewCard>

          <PreviewCard>
            <div className="downloadsample-file">
              <div className="download-list">
                <h4>Download Sample Files</h4>                
                <div className="sample-file">
                  -
                  <Link to="/sample-files/bulk_upload.csv" download target="_blank">
                    Update product details in bulk
                  </Link>
                </div>
              </div>
            </div>
          </PreviewCard>
        </Block>
      </Content>
      <ToastContainer />
    </React.Fragment>
  );
};


export default BulkUpdateAdd;
